// export function jsonToArray(json: any) {
//    var str = JSON.stringify(json, null, 0);
//    var ret = new Uint8Array(str.length);
//    for (var i = 0; i < str.length; i++) {
//       ret[i] = str.charCodeAt(i);
//    }
//    return ret;
// }

export function binArrayToJson(binArray: any) {
   var str = '';
   for (var i = 0; i < binArray.length; i++) {
      str += String.fromCharCode(parseInt(binArray[i]));
   }
   // console.log(str);
   return JSON.parse(str);
}

export function getFileName(res: Response) {
   const fileNameStr = res.headers.get('content-disposition')?.split('filename=')?.[1];
   const fName = fileNameStr?.replaceAll('"', '');

   return fName;
}
